import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { COMPANY } from "../../data/site";
import { MaskLines, Reveal } from "./Motion";

export const CtaBand = ({ title = ["Un été sans piqûres,", "ça se prépare."], text }) => (
  <section className="px-3 md:px-6 pb-6" data-testid="cta-band">
    <div className="relative overflow-hidden rounded-[32px] bg-moss text-cream grain">
      <img src="/images/nebulisation.webp" alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-25 mix-blend-luminosity" />
      <div className="relative z-[2] max-w-[1400px] mx-auto px-6 lg:px-12 py-20 md:py-28 grid lg:grid-cols-[1.4fr_1fr] gap-10 items-end">
        <div>
          <p className="eyebrow text-lime">Intervention en Gironde</p>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-7xl font-extrabold leading-[0.95]">
            <MaskLines lines={title} inView />
          </h2>
        </div>
        <Reveal delay={0.2}>
          <p className="lead-text text-cream/85">{text || "Diagnostic, suppression des gîtes larvaires et traitement choc par nébulisation : appelez-nous ou demandez votre devis gratuit en 1 minute."}</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a href={COMPANY.phoneHref} className="btn btn-lime" data-testid="cta-band-call"><Phone className="w-4 h-4" />{COMPANY.phone}</a>
            <Link to="/contact" className="btn btn-ghost-light" data-testid="cta-band-quote">Devis gratuit<ArrowRight className="w-4 h-4" /></Link>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
